module.exports = __webpack_public_path__ + "img/txt_info1.e675b4d3.png";